import { render, staticRenderFns } from "./exam-analysis.vue?vue&type=template&id=2467bc6a&scoped=true&"
import script from "./exam-analysis.vue?vue&type=script&lang=ts&"
export * from "./exam-analysis.vue?vue&type=script&lang=ts&"
import style0 from "./exam-analysis.vue?vue&type=style&index=0&id=2467bc6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467bc6a",
  null
  
)

export default component.exports